module.exports = __webpack_public_path__ + "static/media/stopred.d5637498.svg";